import type { IsoDate } from '@/shared/lib/dates/iso-date';
import { today } from '@/shared/lib/dates/today';
import type { Task } from '../schemas/task';
import { nextDueOn } from './next-due-on';

/**
 * Completing a repeating task (a periodic check) schedules the next one instead of closing it,
 * with its checklist unticked for the next round.
 */
export function completionPatch(task: Task, on: IsoDate = today()): Partial<Task> {
  const due = nextDueOn(task, on);
  if (!due) return { status: 'done', done_on: on };
  const patch: Partial<Task> = { status: 'todo', done_on: on, due_on: due };
  if (task.checklist?.some((step) => step.done)) {
    patch.checklist = task.checklist.map((step) => ({ ...step, done: false }));
  }
  return patch;
}
